export const lightTheme = {
  button: {
    defaultProps: { className: 'normal-case' },
    styles: {
      variants: {
        filled: {
          gray: {
            backgroud: 'bg-primary',
          },
        },
        text: {
          gray: {
            backgroud: 'text-on-surface-variant',
          },
          teal: {
            backgroud: 'text-primary',
          },
        },
        outlined: {
          red: {
            backgroud: 'text-error',
            border: 'border border-error',
          },
          gray: {
            backgroud: 'text-secondary',
            border: 'border border-secondary',
          },
          teal: {
            backgroud: 'text-primary',
            border: 'border border-primary',
          },
        },
      },
    },
  },
  navbar: {
    defaultProps: { className: 'bg-system' },
  },
  typography: {
    defaultProps: {
      color: 'gray',
      variant: 'paragraph',
    },
    valid: {
      colors: ['black', 'teal', 'blue', 'gray', 'blue-gray', 'indigo', 'amber', 'red'],
      variants: ['h4', 'h5', 'h6', 'paragraph', 'small'],
    },
    styles: {
      colors: {
        black: {
          color: 'text-black',
        },
        teal: {
          color: 'text-primary',
        },
        blue: {
          color: 'text-information',
        },
        gray: {
          color: 'text-on-surface-variant',
        },
        'blue-gray': {
          color: 'text-outline-variant',
        },
        indigo: {
          color: 'text-neutral-40',
        },
        amber: {
          color: 'text-on-surface',
        },
        red: {
          color: 'text-error',
        },
      },
      variants: {
        h4: {
          fontSize: 'text-xl',
          lineHeight: '28px',
          letterSpacing: '0px',
          fontWeight: '700',
        },
        h5: {
          fontSize: 'text-base',
          lineHeight: '24px',
          letterSpacing: '0.15px',
          fontWeight: '700',
        },
        h6: {
          fontSize: 'text-base',
          lineHeight: '24px',
          letterSpacing: '0.5px',
          fontWeight: '700',
        },
        paragraph: {
          fontSize: 'text-base',
          lineHeight: '20px',
          letterSpacing: '0.25px',
          fontWeight: '400',
        },
        small: {
          fontSize: 'text-sm',
          lineHeight: '16px',
          letterSpacing: '0.4px',
          fontWeight: '400',
        },
      },
    },
  },
  list: {
    styles: {
      base: {
        item: {
          initial: {
            display: 'flex',
            alignItems: 'items-center',
            width: 'w-full',
            padding: 'p-3',
            borderRadius: 'rounded-2xl',
            textAlign: 'text-start',
            lightHeight: 'leading-tight',
            transition: 'transition-all',
            bg: 'hover:bg-primary-opacity-10 focus:bg-primary-opacity-10',
            color: 'hover:text-primary focus:text-primary active:text-primary',
            outline: 'outline-none',
          },
          selected: {
            bg: 'bg-primary-opacity-10',
            color: 'text-primary',
          },
        },
      },
    },
  },
  iconButton: {
    styles: {
      variants: {
        filled: {
          gray: {
            backgroud: 'bg-primary',
          },
        },
      },
    },
  },
  input: {
    defaultProps: { color: 'teal' },
    styles: {
      base: {
        input: {
          color: 'text-on-surface-variant',
        },
        label: {
          color: 'peer-placeholder-shown:text-on-surface-variant',
        },
        icon: {
          color: 'text-on-surface-variant',
        },
      },
      variants: {
        outlined: {
          base: {
            input: {
              borderColor: 'placeholder-shown:border-on-surface-variant placeholder-shown:border-t-on-surface-variant',
            },
          },
          colors: {
            input: {
              teal: {
                borderColor: 'border-primary',
                borderColorFocused: 'focus:border-primary',
              },
            },
            label: {
              teal: {
                color: 'text-primary peer-focus:text-primary',
                before: 'before:border-primary peer-focus:before:!border-primary',
                after: 'after:border-primary peer-focus:after:!border-primary',
              },
            },
          },
          error: {
            input: {
              borderColor: 'border-error placeholder-shown:border-t-error placeholder-shown:border-error',
              borderColorFocused: 'focus:border-error',
            },
            label: {
              color: 'text-error peer-focus:text-error peer-placeholder-shown:text-on-surface-variant',
              before: 'before:border-error peer-focus:before:border-error',
              after: 'after:border-error peer-focus:after:border-error',
            },
          },
        },
      },
    },
  },
  link: {
    defaultProps: { className: 'text-information hover:text-primary' },
  },
  accordion: {
    defaultProps: {},
    styles: {
      base: {
        header: {
          initial: {
            py: 'p-3',
            borderWidth: 'border-b border-b-primary',
            color: 'text-blue-gray-700',
            fontFamily: 'font-sans',
            fontSize: 'text-sm',
            fontWeight: 'font-body',
            lineHeight: 'leading-tight',
            hover: 'hover:text-primary',
            transition: 'transition-colors',
          },
          active: { color: 'text-primary' },
        },
      },
    },
  },
  chip: {
    defaultProps: {
      className: 'normal-case',
    },
    valid: {
      variants: ['filled'],
      colors: ['teal', 'red'],
    },
    styles: {
      variants: {
        filled: {
          teal: {
            backgroud: 'bg-primary-opacity-20',
            color: 'text-primary',
          },
          red: {
            backgroud: 'bg-error-opacity-20',
            color: 'text-error',
          },
        },
      },
    },
  },
  switch: {
    valid: {
      colors: ['teal'],
    },
    styles: {
      base: {
        root: {
          display: 'inline-flex',
          alignItems: 'items-center',
          flexDirection: 'flex-row-reverse',
        },
        label: {
          fontSize: 'text-sm',
          lineHeight: '16px',
          letterSpacing: '0.4px',
          fontWeight: '400',
          color: 'text-on-surface-variant',
          ml: 'ml-0',
          mr: 'mr-3',
        },
      },
      colors: {
        teal: {
          input: 'checked:bg-primary',
          circle: 'peer-checked:border-primary',
          before: 'peer-checked:before:bg-primary',
        },
      },
    },
  },
}
export const darkTheme = {
  button: {
    defaultProps: { className: 'normal-case' },
    styles: {
      variants: {
        filled: {
          gray: {
            backgroud: 'bg-primary',
          },
        },
        text: {
          gray: {
            backgroud: 'text-on-surface-variant',
          },
          teal: {
            backgroud: 'text-primary',
          },
        },
        outlined: {
          gray: {
            backgroud: 'text-on-surface-variant',
            border: 'border border-dark-10 bg-highground',
          },
          red: {
            backgroud: 'text-error',
            border: 'border border-error',
          },
        },
        teal: {
          backgroud: 'text-primary',
          border: 'border border-primary',
        },
      },
    },
  },
  navbar: {
    defaultProps: { className: 'bg-dark-6' },
  },
  typography: {
    defaultProps: {
      color: 'gray',
      className: '',
    },
    valid: {
      colors: ['black', 'teal', 'blue', 'gray', 'blue-gray', 'indigo', 'amber', 'red'],
      variants: ['h4', 'h5', 'h6', 'paragraph', 'small'],
    },
    styles: {
      colors: {
        black: {
          color: 'text-white',
        },
        teal: {
          color: 'text-primary',
        },
        blue: {
          color: 'text-information',
        },
        gray: {
          color: 'text-white',
        },
        'blue-gray': {
          color: 'text-outline-variant',
        },
        indigo: {
          color: 'text-dark-10',
        },
        amber: {
          color: 'text-white',
        },
        red: {
          color: 'text-error',
        },
      },
      variants: {
        h4: {
          fontSize: 'text-xl',
          lineHeight: '28px',
          letterSpacing: '0px',
          fontWeight: '700',
        },
        h5: {
          fontSize: 'text-base',
          lineHeight: '24px',
          letterSpacing: '0.15px',
          fontWeight: '700',
        },
        h6: {
          fontSize: 'text-base',
          lineHeight: '24px',
          letterSpacing: '0.5px',
          fontWeight: '700',
        },
        paragraph: {
          fontSize: 'text-base',
          lineHeight: '20px',
          letterSpacing: '0.25px',
          fontWeight: '400',
        },
        small: {
          fontSize: 'text-sm',
          lineHeight: '16px',
          letterSpacing: '0.4px',
          fontWeight: '400',
        },
      },
    },
  },
  iconButton: {
    defaultProps: { className: 'text-white' },
    styles: {
      variants: {
        filled: {
          gray: {
            backgroud: 'bg-primary',
          },
        },
        outlined: {
          gray: {
            border: 'border border-dark-10 bg-highground',
          },
        },
      },
    },
  },
  list: {
    defaultProps: { className: 'text-white' },
    styles: {
      base: {
        item: {
          initial: {
            display: 'flex',
            alignItems: 'items-center',
            width: 'w-full',
            padding: 'p-3',
            borderRadius: 'rounded-2xl',
            textAlign: 'text-start',
            lightHeight: 'leading-tight',
            transition: 'transition-all',
            bg: 'hover:bg-primary-opacity-20 focus:bg-primary-opacity-20',
            color: 'hover:text-primary focus:text-primary active:text-primary',
            outline: 'outline-none',
          },
          selected: {
            bg: 'bg-primary-opacity-20',
            color: 'text-primary',
          },
        },
      },
    },
  },
  input: {
    styles: {
      base: {
        input: {
          color: 'text-white',
        },
        label: {
          color: 'peer-placeholder-shown:text-white',
        },
        icon: {
          color: 'text-white',
        },
      },
      variants: {
        outlined: {
          base: {
            input: {
              borderColor: 'placeholder-shown:border-on-surface-variant placeholder-shown:border-t-on-surface-variant',
            },
          },
          colors: {
            input: {
              teal: {
                borderColor: 'border-primary',
                borderColorFocused: 'focus:border-primary',
              },
              gray: {
                borderColor: 'border-white',
                borderColorFocused: 'focus:border-white',
              },
            },
            label: {
              teal: {
                color: 'text-primary peer-focus:text-primary',
                before: 'before:border-primary peer-focus:before:!border-primary',
                after: 'after:border-primary peer-focus:after:!border-primary',
              },
              gray: {
                color: 'text-white border-white peer-focus:text-white',
                borderColorFocused: 'focus:border-white',
                before: 'before:border-white peer-focus:before:!border-white',
                after: 'after:border-white peer-focus:after:!border-white',
              },
            },
          },
          error: {
            input: {
              borderColor: 'border-error placeholder-shown:border-t-error placeholder-shown:border-error',
              borderColorFocused: 'focus:border-error',
            },
            label: {
              color: 'text-error peer-focus:text-error peer-placeholder-shown:text-white',
              before: 'before:border-error peer-focus:before:border-error',
              after: 'after:border-error peer-focus:after:border-error',
            },
          },
        },
      },
    },
  },
  card: {
    defaultProps: { className: 'bg-card' },
  },
  accordion: {
    defaultProps: {},
    styles: {
      base: {
        header: {
          initial: {
            py: 'p-3',
            borderWidth: 'border-b border-b-primary',
            color: 'text-white',
            fontFamily: 'font-sans',
            fontSize: 'text-sm',
            fontWeight: 'font-body',
            lineHeight: 'leading-tight',
            hover: 'hover:text-primary',
            transition: 'transition-colors',
          },
          active: { color: 'text-primary' },
        },
      },
    },
  },
  chip: {
    defaultProps: {
      className: 'normal-case',
    },
    valid: {
      variants: ['filled'],
      colors: ['teal', 'red', 'yellow'],
    },
    styles: {
      variants: {
        filled: {
          teal: {
            backgroud: 'bg-primary bg-opacity-20',
            color: 'text-primary',
          },
        },
        outlined: {
          gray: {
            backgroud: 'text-white',
            border: 'border border-dark-10 bg-highground',
          },
        },
        ghost: {
          teal: {
            background: 'bg-primary-98',
            color: 'text-white',
          },
          red: {
            backgroud: 'bg-error bg-opacity-20',
            color: 'text-white',
          },
          yellow: {
            backgroud: 'bg-danger bg-opacity-20',
            color: 'text-white',
          },
          blue: {
            backgroud: 'bg-information bg-opacity-20',
            color: 'text-white',
          },
          green: {
            background: 'bg-primary-98',
            color: 'text-white',
          },
          purple: {
            background: 'bg-purple-600',
            color: 'text-white',
          },
          gray: {
            background: 'bg-gray-600',
            color: 'text-white',
          },
        },
      },
    },
  },
  switch: {
    valid: {
      colors: ['teal'],
    },
    styles: {
      base: {
        root: {
          display: 'inline-flex',
          alignItems: 'items-center',
          flexDirection: 'flex-row-reverse',
        },
        label: {
          fontSize: 'text-sm',
          lineHeight: '16px',
          letterSpacing: '0.4px',
          fontWeight: '400',
          color: 'text-white',
          ml: 'ml-0',
          mr: 'mr-3',
        },
      },
      colors: {
        teal: {
          input: 'checked:bg-primary',
          circle: 'peer-checked:border-primary',
          before: 'peer-checked:before:bg-primary',
        },
      },
    },
  },
  dialog: {
    defaultProps: {
      className: 'bg-highground',
    },
  },
  menu: {
    styles: {
      base: {
        menu: {
          bg: 'bg-highground',
        },
      },
    },
  },
  select: {
    styles: {
      base: {
        select: {
          color: 'text-white',
        },
        arrow: {
          initial: {
            color: 'text-white',
          },
        },
        menu: {
          bg: 'bg-highground',
          color: 'text-white',
        },
      },
      variants: {
        outlined: {
          colors: {
            select: {
              gray: {
                close: {
                  borderColor: 'border-white',
                },
                open: {
                  borderColor: 'border-gray-600',
                },
                withValue: {
                  borderColor: 'border-white',
                },
              },
            },
            label: {
              gray: {
                close: {
                  color: 'text-white',
                  before: 'before:border-gray-600',
                  after: 'after:border-gray-600',
                },
                open: {
                  color: 'text-white',
                  before: 'before:border-gray-600',
                  after: 'after:border-gray-600',
                },
                withValue: {
                  color: 'text-gray-600',
                  before: 'before:border-white',
                  after: 'after:border-white',
                },
              },
            },
          },
        },
      },
    },
  },
  checkbox: {
    defaultProps: {
      color: 'blue',
    },
  },
}

export const mappingTheme = {
  light: lightTheme,
  dark: darkTheme,
}
